import { isObjectId } from '@/shared/lib'

/**
 * Токен отправки (BE-53): у бэкенда — 22 символа base64url (128 случайных
 * бит), принимает он `[A-Za-z0-9_-]` длиной до 64 (`GiftSendTokenParamSchema`).
 * Проверяем так же, как бэкенд, а не длину 22: формат выпуска — его дело.
 */
const SEND_TOKEN = /^[A-Za-z0-9_-]{1,64}$/

export const isSendToken = (value: string | undefined | null): value is string =>
  typeof value === 'string' && SEND_TOKEN.test(value)

/** Куда ведёт ссылка на подарок: на отправку (получателю) или на сам подарок (дарителю, «Мои подарки»). */
export type GiftLaunchTarget = { kind: 'send'; token: string } | { kind: 'gift'; giftId: string }

/**
 * `start_param` ссылки `t.me/<бот>/app?startapp=…` (BE-53):
 * - `s_<token>` — карточка в чате и кнопки бота **получателю** («Ваш подарок
 *   сохранён», «Погашение отменено», напоминание о решении);
 * - `g_<giftId>` — кнопки бота **дарителю** (отказ, возврат по таймауту);
 * - голый 24-hex id — старые кнопки, разосланные до BE-53: понимаем как id
 *   подарка (свой подарок откроется, постороннему — «не найден»).
 *
 * Всё остальное — не наша ссылка: `null`, приложение открывается как обычно.
 */
export const parseGiftStartParam = (startParam: string | null): GiftLaunchTarget | null => {
  if (!startParam) {
    return null
  }

  if (startParam.startsWith('s_')) {
    const token = startParam.slice(2)

    return isSendToken(token) ? { kind: 'send', token } : null
  }

  if (startParam.startsWith('g_')) {
    const giftId = startParam.slice(2)

    return isObjectId(giftId) ? { kind: 'gift', giftId } : null
  }

  return isObjectId(startParam) ? { kind: 'gift', giftId: startParam } : null
}
